import _ from 'lodash';
require('../components/autocomplete');

if ( $('.show-hide-advanced-search').length) {
    $( ".show-hide-advanced-search" ).click(function(event) {
        event.preventDefault();
        $('.advanced-search-box-container').slideToggle();
        $(this).find('.open, .closed').toggle();
        $(this).toggleClass('open');
    });
}

if ( $('.show-hide-map').length) {
    $( ".show-hide-map" ).on('click', function(event) {
        event.preventDefault();
        var self = $(this);
        $('#results-map').slideToggle('fast', function(){
            self.toggleClass('open');
            self.find('.open, .closed').toggle();
            var center = maps[0].map.getCenter();
            google.maps.event.trigger(maps[0].map, "resize");
            maps[0].map.setCenter(center);
            google.maps.event.trigger(maps[0].map, "resize");
        });
    });
}

if ( $('.advanced-search-reset-button').length) {
    $( ".advanced-search-reset-button" ).on('click', function(event) {
        $('.advanced-search').find("input[type=text], textarea").val("");
        $("#lat").val("51.509865");
        $("#lng").val("-0.118092");
        $("#postcode").val("");
        $("#postcode").prop('disabled', true);
        $("#postcodeprefix").val("");
        $("#postcodeprefix").prop('disabled', true);
        $("#borough").val("");
        $("#borough").prop('disabled', true);
        $('.advanced-search select').each(function( index ) {
            this.selectedIndex = 0;
        });
        $.uniform.update();
        return false;
    });
}

$('#outsideLondonCB').change(function() {
    var actualUrl = window.location.href;
    if( actualUrl.indexOf("outside") > -1 )
    {
        if($(this).is(":checked")) {
            var newUrl = location.href.replace("outside=0", "outside=1");
        }
        else {
            var newUrl = location.href.replace("outside=1", "outside=0");
        }
    }
    else
    {
        if($(this).is(":checked")) {
            var newUrl = actualUrl + '&outside=1';
        }
        else {
            var newUrl = actualUrl + '&outside=0';
        }
    }
    if( actualUrl.indexOf("showmap") == -1 )
    {
        newUrl = newUrl + '&showmap=1';
    }
    window.location.href = newUrl;
});

// Sort by on results page.
if ( $('#sort_by').length ) {
    $('#sort_by').on('change', function() {
        var url = window.location.href;
        var selectValue = $(this).val();
        var new_url = removeURLParameter(url, "sort_by");
        if (new_url.indexOf('?') > -1){
            new_url += '&sort_by='+selectValue
        }else{
            new_url += '?sort_by='+selectValue
        }
        window.location.href = new_url;
    })
}

$(window).on('load', function() {
    window.equalheight('.featured-properties .equalheight');
    window.equalheight('.featured-properties .featured-property a');
    window.equalheight('.search-result-item a');
    window.equalheight('.search-result-item .dashboard-listing');
    window.equalheight('.dashboard-listing .teaser-container .equalheight');
    window.equalheight('.premium-listing .teaser-container .equalheight');
});

$(window).resize(function(){
    window.equalheight('.featured-properties .equalheight');
    window.equalheight('.featured-properties .featured-property a');
    window.equalheight('.search-result-item a');
    window.equalheight('.search-result-item .dashboard-listing');
    window.equalheight('.dashboard-listing .teaser-container .equalheight');
    window.equalheight('.premium-listing .teaser-container .equalheight');
});

window.afterMapLoaded = function(){
    var w=window,
    d=document,
    e=d.documentElement,
    g=d.getElementsByTagName('body')[0],
    x=w.innerWidth||e.clientWidth||g.clientWidth,
    y=w.innerHeight||e.clientHeight||g.clientHeight;
    var map = maps[0].map;
    var shapes = maps[0].shapes;
    var shapesLength = shapes.length;
    var markers = maps[0].markers;
    var bounds = new google.maps.LatLngBounds();
    for (var i=0; i<maps[0].markers.length; i++) {
        if(markers[i].getVisible()) {
            bounds.extend( markers[i].getPosition() );
        }
    }
    map.fitBounds(bounds);

    if( x < 768 ){
        _.forEach(markers, function(value, key) {
            google.maps.event.clearListeners(markers[key], 'click');
            google.maps.event.addListener(markers[key], 'click', function() {
                var stickyHeight = $('.sticky').innerHeight();
                if( key % 2 !== 0 ){
                    var infoWindowNumber = (key-1) / 2;
                    $('.mobile-infowindow').removeClass('show');
                    $('#mobile-infowindow-' + infoWindowNumber).toggleClass('show');
                    $('html, body').animate({
                        scrollTop: $('#mobile-infowindow-' + infoWindowNumber).offset().top - stickyHeight
                    }, 1000);
                }
            });
        });
    }

    google.maps.event.addListenerOnce(map, 'idle', function() {
        $('.overlay').hide();
    });
}


if (!google.maps.Polygon.prototype.getBounds) {
    google.maps.Polygon.prototype.getBounds = function () {
        var bounds = new google.maps.LatLngBounds();
        this.getPath().forEach(function (element, index) { bounds.extend(element); });
        return bounds;
    }
}

function removeURLParameter(url, parameter) {
    var urlparts= url.split('?');
    if (urlparts.length>=2) {

        var prefix= encodeURIComponent(parameter)+'=';
        var pars= urlparts[1].split(/[&;]/g);
        for (var i= pars.length; i-- > 0;) {
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        url= urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
        return url;
    } else {
        return url;
    }
}
